import { useCallback, useState } from "react";
import { getBaseUrl } from "../../functions/getBaseUrl";
import { GEO_URL } from "./constants";

/**
 * @returns {Promise<{ lat: number; lng: number }>}
 */
export const getUserPoisition = async () => {
  const res = await fetch(GEO_URL);
  const { latitude, longitude } = await res.json();

  return { lat: Number(latitude), lng: Number(longitude) };
};

export const useReactKey = () => {
  const [key, setKey] = useState(crypto.randomUUID());
  const refreshKey = useCallback(() => setKey(crypto.randomUUID()), []);

  return [key, refreshKey];
};

export const generateTourUrl = tourParams => {
  const redirectUrl = new URL("/preparing", getBaseUrl());
  // redirectUrl for tests
  // const redirectUrl = new URL("http://localhost:3000/preparing/");
  const hashedParams = btoa(unescape(encodeURIComponent(JSON.stringify(tourParams))));

  redirectUrl.hash = hashedParams;

  return redirectUrl.toString();
};
